import { render, staticRenderFns } from "./TenantDetailTable.vue?vue&type=template&id=d05070bc&scoped=true&"
import script from "./TenantDetailTable.vue?vue&type=script&lang=ts&"
export * from "./TenantDetailTable.vue?vue&type=script&lang=ts&"
import style0 from "./TenantDetailTable.vue?vue&type=style&index=0&id=d05070bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d05070bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VSimpleTable,VTextField})
